import { SignInPage } from '@backstage/core-components';
import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import {
  byconxForgejoAuthApi,
  byconxForgejoAuthApiRef,
} from './byconxForgejoAuth';
import { navModule } from './modules/nav';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        provider={{
          id: 'forgejo-auth-provider',
          title: 'Forgejo',
          message: 'Sign in using Forgejo',
          apiRef: byconxForgejoAuthApiRef,
        }}
      />
    ),
  },
});

const forgejoAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    byconxForgejoAuthApi,
    signInPage,
  ],
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    forgejoAuthModule,
  ],
});
